/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   เลือกสินค้าสำหรับรับเข้าโดยไม่มีใบสั่งซื้อ (รับของจากลูกค้า)

   รวมทะเบียน วัตถุดิบ / ส่วนผสม / ภาชนะบรรจุ / บรรจุภัณฑ์
   เลือกได้หลายรายการ แล้วไปกรอกจำนวนในตารางของหน้ารับสินค้า
============================================================ */
import { useEffect, useMemo, useState } from "react";
import { Modal, Table, Input, Button, Flex, Space, Tag, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import GoodsReceiptService from "../../../../service/ERP/GoodsReceipt.service";
import TagItemTypes from "../../../badge-and-tag/ERP/tags-item-type/TagItemTypes";

const grService = GoodsReceiptService();

const TYPES = ["Raw Material", "Ingredients", "Packing", "Packaging"];

export default function ModalGrItems({ show, close, values, selected = [] }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [types, setTypes] = useState(TYPES);
  const [keys, setKeys] = useState([]);

  const load = () => {
    setLoading(true);
    grService
      .itemsAll("")
      .then((res) => setRows(res.data?.data || []))
      .catch(() => message.error("โหลดรายการสินค้าไม่สำเร็จ"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (show) {
      setSearch("");
      setTypes(TYPES);
      setKeys([]);
      load();
    }
  }, [show]);

  const chosen = useMemo(
    () => (selected || []).map((s) => s.stcode),
    [selected]
  );

  /* กรองด้วยคำค้นและประเภทสินค้าในฝั่งหน้าจอ ไม่ต้องยิง API ซ้ำ */
  const data = useMemo(() => {
    const q = (search || "").trim().toLowerCase();
    return (rows || []).filter((r) => {
      if (types.length > 0 && !types.includes(r.typename)) return false;
      if (!q) return true;
      return (
        String(r.stcode || "").toLowerCase().includes(q) ||
        String(r.stname || "").toLowerCase().includes(q)
      );
    });
  }, [rows, search, types]);

  const toggleType = (t) =>
    setTypes((prev) =>
      prev.includes(t) ? prev.filter((v) => v !== t) : [...prev, t]
    );

  const handleConfirm = () => {
    const picked = (rows || [])
      .filter((r) => keys.includes(r.stcode) && !chosen.includes(r.stcode))
      .map((r) => ({
        code: r.stcode,
        pocode: null,
        podate: null,
        stcode: r.stcode,
        stname: r.stname,
        typename: r.typename,
        price: 0,
        qty_buy: 0,
        recamount: 0,
        qty: 1,
        discount: 0,
        unit: r.unit || "ชิ้น",
        shelf_life: Number(r.shelf_life || 0),
      }));

    if (picked.length === 0) {
      message.warning("กรุณาเลือกสินค้าอย่างน้อย 1 รายการ");
      return;
    }
    values([...(selected || []), ...picked]);
    close(false);
  };

  return (
    <Modal
      title="เลือกสินค้าที่รับเข้า"
      open={show}
      onCancel={() => close(false)}
      onOk={handleConfirm}
      okText="เลือก"
      cancelText="ปิด"
      width={900}
      destroyOnClose
    >
      <Space direction="vertical" style={{ display: "flex" }} size="middle">
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder="ค้นหารหัส / ชื่อสินค้า"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Flex gap={8} wrap align="center">
          <Button size="small" onClick={() => setTypes(TYPES)}>
            ทั้งหมด
          </Button>
          {TYPES.map((t) => (
            <span
              key={t}
              onClick={() => toggleType(t)}
              style={{
                cursor: "pointer",
                display: "inline-block",
                opacity: types.includes(t) ? 1 : 0.35,
              }}
            >
              <TagItemTypes data={t} />
            </span>
          ))}
          <Tag color="default">{data.length} รายการ</Tag>
        </Flex>

        <Table
          size="small"
          bordered
          rowKey="stcode"
          loading={loading}
          dataSource={data}
          pagination={{ pageSize: 10, showSizeChanger: false }}
          scroll={{ x: "max-content", y: 360 }}
          rowSelection={{
            selectedRowKeys: keys,
            onChange: setKeys,
            getCheckboxProps: (record) => ({
              disabled: chosen.includes(record.stcode),
            }),
          }}
          columns={[
            { title: "รหัสสินค้า", dataIndex: "stcode", width: 150 },
            { title: "ชื่อสินค้า", dataIndex: "stname" },
            {
              title: "ประเภท",
              dataIndex: "typename",
              width: 140,
              render: (v) => <TagItemTypes data={v} />,
            },
            { title: "หน่วย", dataIndex: "unit", width: 90, align: "center" },
            {
              title: "อายุสินค้า",
              dataIndex: "shelf_life",
              width: 110,
              align: "right",
              render: (v) => `${Number(v || 0)} วัน`,
            },
          ]}
        />
      </Space>
    </Modal>
  );
}
